
export enum EmployeeRoleCd {
	DR_APPROVER = 'DRApprover',
	DR_REVIEWER = 'DRReviewer',
	DR_TEST_APPROVER = 'DRTestApprover',
	DR_TEST_REVIEWER = 'DRTestReviewer'}
